import { render, staticRenderFns } from "./publicClass.vue?vue&type=template&id=03b45a2e&scoped=true"
import script from "./publicClass.vue?vue&type=script&lang=js"
export * from "./publicClass.vue?vue&type=script&lang=js"
import style0 from "./publicClass.vue?vue&type=style&index=0&id=03b45a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b45a2e",
  null
  
)

export default component.exports